module.exports = __webpack_public_path__ + "img/laa_with_tillys_scrunchies.15d0f9a1.jpg";